// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__Qif-d {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    /*grid-template-rows: repeat(3, 1fr);*/

    /*max-height: calc(100vh - var(--header-height) - 40px);*/
}

.styles_box__GJuT4 {
    border: 0.25px solid #7b848e;
    border-right: 0;
    border-bottom: 0;
    position: relative;
    padding: 57px;
    cursor: pointer;
    transition: background-color 0.4s;
    max-height: 366px;
    /*padding-top: 16%;*/
    display: flex;
    flex-direction: column;
    text-align: center;
    background: #fbfbfb;
    min-height: 293px;
}

.styles_box__GJuT4:before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(var(--primary-color-light), var(--white-active));
    opacity: 0;
    transition: opacity 0.4s;
}

/*.box:hover {*/
/*    border-color: var(--primary-color-active);*/
/*}*/

.styles_box__GJuT4:hover:before {
    opacity: 1;
}

/*.box:hover .number {*/
/*    color: var(--primary-color-active);*/
/*}*/

.styles_boxInner__MFbAk {
    /*position: absolute;*/
    /*top: 0;*/
    /*height: 100%;*/
}

.styles_box__GJuT4:nth-child(3n) {
    border-right: 0.25px solid #7b848e;
}

.styles_box__GJuT4:nth-last-child(1),
.styles_box__GJuT4:nth-last-child(2),
.styles_box__GJuT4:nth-last-child(3) {
    border-bottom: 0.25px solid #7b848e;
}

.styles_box__GJuT4 p {
    transition:
        transform 0.4s,
        color 0.4s;
}

/*.box:hover {*/
/*    background: var(--primary-color);*/
/*    color: #fff;*/
/*}*/

/*.box:hover p {*/
/*    color: #fff;*/
/*    transform: scale(1.3) translateY(0px);*/
/*}*/

.styles_number__kTPMk {
    position: absolute;
    top: 26px;
    left: 14px;
    font-size: 30px;
    font-weight: 300;
    transition: color 0.4s;
    /*color: #7b848e;*/
    color: #000;
}

.styles_folderContainer__ixhe2 {
    position: relative;
    margin: auto;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    --folder-offset: 52px;
}

/*.folderContainer.responsive {*/
/*    --folder-offset: 32px;*/
/*}*/

/*.folderContainer.secondary {*/
/*    --folder-offset: 52px;*/
/*}*/

.styles_folder__UsDMz {
    position: relative;
    /*width: 226px;*/
    margin: auto;
    /*max-height: 100%;*/
    /*width: 24vh;*/
}

.styles_itemWrapper__kxNKl {
    width: 140px;
    height: 140px;
    margin: auto;
    position: relative;
    max-height: 100%;
}

.styles_item__\\+pBgZ {
    width: inherit;
    height: 140px;
    border: 0.5px solid #7b848e;
    position: absolute;
    --offset: 8px;
    margin: var(--offset) auto 0;
    left: calc(var(--offset) * -1);
    top: calc(var(--offset) * -1);
    background: #fff;
}

.styles_item__\\+pBgZ:before,
.styles_item__\\+pBgZ:after {
    content: '';
    display: block;
    position: absolute;
    width: inherit;
    height: inherit;
    border: inherit;
    background: inherit;
}

.styles_item__\\+pBgZ:before {
    left: var(--offset);
    top: var(--offset);
}

.styles_item__\\+pBgZ:after {
    left: calc(var(--offset) * 2);
    top: calc(var(--offset) * 2);
}

.styles_imgContainer__JE3LA {
    position: absolute;
    top: 0;
    width: 100%;
    bottom: calc(var(--folder-offset) * -1);
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 100%;
}

.styles_folderImg__2rZ4b {
    display: block;
    width: 200px;
    min-width: 180px;
    max-width: 130%;

    /*max-height: 80%;*/
    /*width: auto;*/
    /*display: block;*/

    margin: calc(var(--folder-offset, 32px) + 32px) auto 0;

    --icon-color-custom: #1650b4;
    --icon-fill-color-custom: rgba(240, 243, 247, 0.5);
}

.styles_folder-color-yellow__pFHRh {
    --icon-color-custom: #fffc00;
    --icon-fill-color-custom: rgba(255, 252, 0, 0.25);
}

.styles_folder-color-orange__d3-9N {
    --icon-color-custom: #bc5200;
    --icon-fill-color-custom: rgba(188, 88, 0, 0.25);
}

.styles_typeImg__57gst {
    width: 100px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 32px 30px;
    /*margin-top: 0px;*/
}

.styles_typeImg__57gst.styles_secondary__coFEM {
    z-index: 1;
    /*margin-top: -50px;*/
    /*margin-left: 20px;*/
}

.styles_folderImg__2rZ4b.styles_secondary__coFEM {
    position: relative;
    z-index: 2;
}

.styles_type__Ev6k\\+ {
    margin: calc(var(--folder-offset, 32px) - 10px) auto 0;
    text-align: center;
    color: var(--primary-color);
    max-width: 100%;
    white-space: pre-wrap;
    line-height: 24px;
    display: flex;
    grid-gap: 10px;
    align-items: center;
    justify-content: center;
}

@media (max-height: 1100px) {
    .styles_responsive__iE5FQ .styles_container__Qif-d {
        grid-template-rows: repeat(3, 1fr);
        max-height: calc(100vh - var(--header-height) - 40px);
    }

    .styles_box__GJuT4.styles_responsive__iE5FQ {
        min-height: calc((100vh - var(--header-height) - 80px) / 3);
        padding: 0;
    }

    .styles_responsive__iE5FQ .styles_folder__UsDMz {
        max-height: 100%;
        width: 24vh;
    }

    .styles_responsive__iE5FQ .styles_itemWrapper__kxNKl {
        width: 13vh;
        height: 13vh;
    }

    .styles_responsive__iE5FQ .styles_item__\\+pBgZ {
        height: 13vh;
    }

    .styles_responsive__iE5FQ .styles_folderImg__2rZ4b {
        width: 18vh;
        min-width: 18vh;
    }

    .styles_responsive__iE5FQ .styles_typeImg__57gst {
        width: 10vh;
        margin: 3.5vh 8vh;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Overview/OverviewCategories/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,sCAAsC;;IAEtC,yDAAyD;AAC7D;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,iCAAiC;IACjC,iBAAiB;IACjB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kFAAkF;IAClF,UAAU;IACV,wBAAwB;AAC5B;;AAEA,eAAe;AACf,iDAAiD;AACjD,IAAI;;AAEJ;IACI,UAAU;AACd;;AAEA,uBAAuB;AACvB,0CAA0C;AAC1C,IAAI;;AAEJ;IACI,sBAAsB;IACtB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;;IAGI,mCAAmC;AACvC;;AAEA;IACI;;kBAEc;AAClB;;AAEA,eAAe;AACf,wCAAwC;AACxC,mBAAmB;AACnB,IAAI;;AAEJ,iBAAiB;AACjB,mBAAmB;AACnB,6CAA6C;AAC7C,IAAI;;AAEJ;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA,gCAAgC;AAChC,6BAA6B;AAC7B,IAAI;;AAEJ,+BAA+B;AAC/B,6BAA6B;AAC7B,IAAI;;AAEJ;IACI,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,aAAa;IACb,4BAA4B;IAC5B,8BAA8B;IAC9B,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,eAAe;;IAEf,mBAAmB;IACnB,eAAe;IACf,kBAAkB;;IAElB,sDAAsD;;IAEtD,4BAA4B;IAC5B,kDAAkD;AACtD;;AAEA;IACI,4BAA4B;IAC5B,iDAAiD;AACrD;;AAEA;IACI,4BAA4B;IAC5B,gDAAgD;AACpD;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,sDAAsD;IACtD,kBAAkB;IAClB,2BAA2B;IAC3B,eAAe;IACf,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,cAAc;IACd,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI;QACI,kCAAkC;QAClC,qDAAqD;IACzD;;IAEA;QACI,2DAA2D;QAC3D,UAAU;IACd;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;AACJ","sourcesContent":[".container {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    /*grid-template-rows: repeat(3, 1fr);*/\n\n    /*max-height: calc(100vh - var(--header-height) - 40px);*/\n}\n\n.box {\n    border: 0.25px solid #7b848e;\n    border-right: 0;\n    border-bottom: 0;\n    position: relative;\n    padding: 57px;\n    cursor: pointer;\n    transition: background-color 0.4s;\n    max-height: 366px;\n    /*padding-top: 16%;*/\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    background: #fbfbfb;\n    min-height: 293px;\n}\n\n.box:before {\n    content: '';\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: linear-gradient(var(--primary-color-light), var(--white-active));\n    opacity: 0;\n    transition: opacity 0.4s;\n}\n\n/*.box:hover {*/\n/*    border-color: var(--primary-color-active);*/\n/*}*/\n\n.box:hover:before {\n    opacity: 1;\n}\n\n/*.box:hover .number {*/\n/*    color: var(--primary-color-active);*/\n/*}*/\n\n.boxInner {\n    /*position: absolute;*/\n    /*top: 0;*/\n    /*height: 100%;*/\n}\n\n.box:nth-child(3n) {\n    border-right: 0.25px solid #7b848e;\n}\n\n.box:nth-last-child(1),\n.box:nth-last-child(2),\n.box:nth-last-child(3) {\n    border-bottom: 0.25px solid #7b848e;\n}\n\n.box p {\n    transition:\n        transform 0.4s,\n        color 0.4s;\n}\n\n/*.box:hover {*/\n/*    background: var(--primary-color);*/\n/*    color: #fff;*/\n/*}*/\n\n/*.box:hover p {*/\n/*    color: #fff;*/\n/*    transform: scale(1.3) translateY(0px);*/\n/*}*/\n\n.number {\n    position: absolute;\n    top: 26px;\n    left: 14px;\n    font-size: 30px;\n    font-weight: 300;\n    transition: color 0.4s;\n    /*color: #7b848e;*/\n    color: #000;\n}\n\n.folderContainer {\n    position: relative;\n    margin: auto;\n    max-height: 100%;\n    display: flex;\n    flex-direction: column;\n    --folder-offset: 52px;\n}\n\n/*.folderContainer.responsive {*/\n/*    --folder-offset: 32px;*/\n/*}*/\n\n/*.folderContainer.secondary {*/\n/*    --folder-offset: 52px;*/\n/*}*/\n\n.folder {\n    position: relative;\n    /*width: 226px;*/\n    margin: auto;\n    /*max-height: 100%;*/\n    /*width: 24vh;*/\n}\n\n.itemWrapper {\n    width: 140px;\n    height: 140px;\n    margin: auto;\n    position: relative;\n    max-height: 100%;\n}\n\n.item {\n    width: inherit;\n    height: 140px;\n    border: 0.5px solid #7b848e;\n    position: absolute;\n    --offset: 8px;\n    margin: var(--offset) auto 0;\n    left: calc(var(--offset) * -1);\n    top: calc(var(--offset) * -1);\n    background: #fff;\n}\n\n.item:before,\n.item:after {\n    content: '';\n    display: block;\n    position: absolute;\n    width: inherit;\n    height: inherit;\n    border: inherit;\n    background: inherit;\n}\n\n.item:before {\n    left: var(--offset);\n    top: var(--offset);\n}\n\n.item:after {\n    left: calc(var(--offset) * 2);\n    top: calc(var(--offset) * 2);\n}\n\n.imgContainer {\n    position: absolute;\n    top: 0;\n    width: 100%;\n    bottom: calc(var(--folder-offset) * -1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    max-height: 100%;\n}\n\n.folderImg {\n    display: block;\n    width: 200px;\n    min-width: 180px;\n    max-width: 130%;\n\n    /*max-height: 80%;*/\n    /*width: auto;*/\n    /*display: block;*/\n\n    margin: calc(var(--folder-offset, 32px) + 32px) auto 0;\n\n    --icon-color-custom: #1650b4;\n    --icon-fill-color-custom: rgba(240, 243, 247, 0.5);\n}\n\n.folder-color-yellow {\n    --icon-color-custom: #fffc00;\n    --icon-fill-color-custom: rgba(255, 252, 0, 0.25);\n}\n\n.folder-color-orange {\n    --icon-color-custom: #bc5200;\n    --icon-fill-color-custom: rgba(188, 88, 0, 0.25);\n}\n\n.typeImg {\n    width: 100px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    margin: 32px 30px;\n    /*margin-top: 0px;*/\n}\n\n.typeImg.secondary {\n    z-index: 1;\n    /*margin-top: -50px;*/\n    /*margin-left: 20px;*/\n}\n\n.folderImg.secondary {\n    position: relative;\n    z-index: 2;\n}\n\n.type {\n    margin: calc(var(--folder-offset, 32px) - 10px) auto 0;\n    text-align: center;\n    color: var(--primary-color);\n    max-width: 100%;\n    white-space: pre-wrap;\n    line-height: 24px;\n    display: flex;\n    grid-gap: 10px;\n    align-items: center;\n    justify-content: center;\n}\n\n@media (max-height: 1100px) {\n    .responsive .container {\n        grid-template-rows: repeat(3, 1fr);\n        max-height: calc(100vh - var(--header-height) - 40px);\n    }\n\n    .box.responsive {\n        min-height: calc((100vh - var(--header-height) - 80px) / 3);\n        padding: 0;\n    }\n\n    .responsive .folder {\n        max-height: 100%;\n        width: 24vh;\n    }\n\n    .responsive .itemWrapper {\n        width: 13vh;\n        height: 13vh;\n    }\n\n    .responsive .item {\n        height: 13vh;\n    }\n\n    .responsive .folderImg {\n        width: 18vh;\n        min-width: 18vh;\n    }\n\n    .responsive .typeImg {\n        width: 10vh;\n        margin: 3.5vh 8vh;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__Qif-d`,
	"box": `styles_box__GJuT4`,
	"boxInner": `styles_boxInner__MFbAk`,
	"number": `styles_number__kTPMk`,
	"folderContainer": `styles_folderContainer__ixhe2`,
	"folder": `styles_folder__UsDMz`,
	"itemWrapper": `styles_itemWrapper__kxNKl`,
	"item": `styles_item__+pBgZ`,
	"imgContainer": `styles_imgContainer__JE3LA`,
	"folderImg": `styles_folderImg__2rZ4b`,
	"folder-color-yellow": `styles_folder-color-yellow__pFHRh`,
	"folder-color-orange": `styles_folder-color-orange__d3-9N`,
	"typeImg": `styles_typeImg__57gst`,
	"secondary": `styles_secondary__coFEM`,
	"type": `styles_type__Ev6k+`,
	"responsive": `styles_responsive__iE5FQ`
};
export default ___CSS_LOADER_EXPORT___;
